/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerificationResponse
 */
export interface VerificationResponse {
    /**
     * 
     * @type {string}
     * @memberof VerificationResponse
     */
    username?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationResponse
     */
    known?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationResponse
     */
    finished?: boolean;
}

/**
 * Check if a given object implements the VerificationResponse interface.
 */
export function instanceOfVerificationResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VerificationResponseFromJSON(json: any): VerificationResponse {
    return VerificationResponseFromJSONTyped(json, false);
}

export function VerificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': !exists(json, 'username') ? undefined : json['username'],
        'known': !exists(json, 'known') ? undefined : json['known'],
        'finished': !exists(json, 'finished') ? undefined : json['finished'],
    };
}

export function VerificationResponseToJSON(value?: VerificationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'known': value.known,
        'finished': value.finished,
    };
}

